import { useState } from 'react';
import { AccountUser, CreateAccountUserRequest, DeleteAccountUserRequest, TimezoneRequest } from 'vopay';
import { api } from '@/services/api.config';

export default function useAccountUsers() {
  const [fetching, setFetching] = useState(false);
  const [creating, setCreating] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [users, setUsers] = useState<AccountUser[]>([]);

  async function fetchUsers(params: TimezoneRequest, bearer?: string) {
    try {
      setFetching(true);
      const res = await api.fetchAccountUsers(params, bearer);
      if (!res.Success) throw new Error(res.ErrorMessage);
      setUsers(res.Users);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  async function createUser(params: CreateAccountUserRequest, bearer?: string) {
    try {
      setCreating(true);
      const res = await api.postCreateAccountUser(params, bearer);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setCreating(false);
    }
  }

  async function deleteUser(params: DeleteAccountUserRequest, bearer?: string) {
    try {
      setDeleting(true);
      const res = await api.postDeleteAccountUser(params, bearer);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setDeleting(false);
    }
  }

  return {
    fetching,
    creating,
    deleting,
    users,
    fetchUsers,
    createUser,
    deleteUser,
  };
}
